const TRACKED_ATTRS_NAME = 'ddcstdata';
const FinaneFormTrackingId = ['FINANCE', 'PREQUAL'];

const formTrackingAttributesInjector = ({
	isDomainSSLEnabled,
	isSecureLoginEnabled
}) => {
	const trackedData = sessionStorage.getItem(TRACKED_ATTRS_NAME) || '';

	window.DDC.dataLayer.events.listener.listen(
		'ddc.form.submission',
		({ element }) => {
			if (element && element.closest('form')) {
				const { formTrackingId } = element.closest('form').dataset;
				// Apply for unsecured financing form only
				if (
					FinaneFormTrackingId.includes(formTrackingId) &&
					(!isDomainSSLEnabled || !isSecureLoginEnabled)
				) {
					const financeForm = $(element.closest('form'));
					const trackedDataFormField = financeForm.find(
						'input[name="ddcstdata"]'
					);
					if (trackedDataFormField.length) {
						trackedDataFormField.attr('value', trackedData);
					} else {
						financeForm.append(
							`<input type='hidden' name=${TRACKED_ATTRS_NAME} class='hidden' data-id value=${trackedData}>`
						);
					}
				}
			}
		}
	);
};

export default formTrackingAttributesInjector;
